import { colors } from "@mui/material";
import { deepPurple, grey } from "@mui/material/colors";

const colorConfigs = {
  sidebar: {
    bg: "#233044",
    color: "#eeeeee",
    hoverBg: "#098456",
    activeBg: "#098456",
  },
  topbar: {
    bg: "#fff",
    color: "#000",
  },
  mainBg: colors.grey["100"],
};

export default colorConfigs;
